import { Box, useTheme } from '@mui/material';
import React from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend
);

function EnergyChartPower({ data, labels, title }) {
    const { typography } = useTheme();

    return (
        <Line
            style={{ overflow: 'scroll' }}
            options={{
                responsive: true,
                maintainAspectRatio: true,
                animation: false,
                plugins: {
                    legend: {
                        position: 'top',
                        display: true,
                    },
                    title: {
                        display: false,
                        position: 'left',
                        text: 'Temperature in Celsius Degree',
                    },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                    },
                    filler: {
                        propagate: true,
                    },
                },
                spacing: 1,
                aspectRatio: 4,
                scales: {
                    y: {
                        ticks: {
                            font: {
                                size: 10,
                            },
                        },
                    },
                    x: {
                        ticks: {
                            font: {
                                size: 10,
                            },
                        },
                    },
                },
            }}
            data={{
                labels: labels,
                datasets: data,
            }}
        />
    );
}

export default EnergyChartPower;
